import React from "react";
import EmployeesByTeamChart from "./EmployeesByTeamChart";
import HiringTrendChart from "./HiringTrendChart";
import TopSkillsChart from "./TopSkillsChart";
import DocumentVerificationChart from "./DocumentVerificationChart";

export default function ChartsContainer() {
  return (
    // Uses 12-column grid or flexible grid layout so all 4 fill the screen perfectly
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 w-full mt-6">
      <EmployeesByTeamChart />
      <HiringTrendChart />
      <TopSkillsChart />
      <DocumentVerificationChart />
    </div>
  );
}
